export default __webpack_public_path__ + "static/img/preloader-nostars.9308bf1.gif";